export const initialState = {
	appStateV2: {},
	isAppStateV2Loaded: false,
	isSavingAppStateV2: false
};

export default initialState;
